<template>
  <div class="app-wrapper" :class="classObj">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"></div>
    <app-header-2 class="app-header"/>

     <!-- <sidebar class="sidebar-container"></sidebar> -->
     <div class="main-container">
       <!--<navbar></navbar>-->
       <!-- <breadcrumb ></breadcrumb> -->
        <div style="margin-top: 49px;"></div>
       <app-main></app-main>
     </div>
    <right-panel/>
  </div>
</template>

<script>
  import {Navbar, Sidebar, AppMain} from './components'
  import ResizeMixin from './mixin/ResizeHandler'
  import RightPanel from '@/components/RightPanel'
  import Breadcrumb from '@/components/Breadcrumb'
import AppHeader2 from './components/AppHeader2.vue'
  export default {
    name: 'layout2',
    components: {
      Navbar,
      Sidebar,
      AppMain,
      RightPanel,
      AppHeader2,
  Breadcrumb
    },
    mixins: [ResizeMixin],
    computed: {
      sidebar() {
        return this.$store.state.app.sidebar
      },
      device() {
        return this.$store.state.app.device
      },
      classObj() {
        return {
          hideSidebar: !this.sidebar.opened,
          openSidebar: this.sidebar.opened,
          withoutAnimation: this.sidebar.withoutAnimation,
          mobile: this.device === 'mobile'
        }
      }
    },
    methods: {
      handleClickOutside() {
        this.$store.dispatch('CloseSideBar', {withoutAnimation: false})
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    // &.mobile.openSidebar {
    //   position: fixed;
    //   top: 0;
    // }
  }

  .drawer-bg {
    // background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    // z-index: 999;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout2.vue